import { OptionEntity } from 'types/OptionEntity';

export const searchFilterOptionEntity = <O extends OptionEntity>(arr: O[], search: string): O[] => {
  const searchString = search.toLowerCase().trim();

  return arr.filter(({ value }) => value.toLowerCase().includes(searchString));
};
